import { SVGProps } from 'react'

const Stopwatch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" {...props}>
    <defs>
      <style>{'.cls-2{fill:#fff}'}</style>
    </defs>
    <circle
      cx={28}
      cy={28}
      r={28}
      style={{
        fill: '#d3b1e2'
      }}
    />
    <path
      d="M38.3 20.3a1.36 1.36 0 0 0 1.91 0 1.35 1.35 0 0 0 0-1.91l-2-2a1.35 1.35 0 1 0-1.91 1.91ZM17.7 20.3l1-1 1-1a1.35 1.35 0 0 0-1.91-1.91l-1 1-1 1a1.35 1.35 0 0 0 0 1.91 1.36 1.36 0 0 0 1.91 0Z"
      className="cls-2"
    />
    <path
      d="M29.35 17.26v-1.42h1.35a1.35 1.35 0 0 0 0-2.7h-5.4a1.35 1.35 0 0 0 0 2.7h1.35v1.42a12.84 12.84 0 1 0 2.7 0ZM28 40.16A10.14 10.14 0 1 1 38.13 30 10.13 10.13 0 0 1 28 40.16Z"
      className="cls-2"
    />
    <path
      d="m32.07 30.89-2.72-1.63v-4.64a1.35 1.35 0 0 0-2.7 0V30a1.38 1.38 0 0 0 .65 1.16l3.38 2a1.35 1.35 0 1 0 1.39-2.32Z"
      className="cls-2"
    />
  </svg>
)
export default Stopwatch
